// The three places someone can land after signing in. One login decides which they may use.
export const AREAS = ['admin', 'portal', 'subcon'] as const
export type Area = (typeof AREAS)[number]

export const AREA_INFO: Record<Area, { label: string; description: string; home: string }> = {
  admin: { label: 'Briary admin', description: 'Projects, plots, money and operations', home: '/admin' },
  portal: { label: 'Client portal', description: 'Your sites, plots, photos and documents', home: '/portal' },
  subcon: { label: 'Subcontractor', description: 'Air test bookings and results', home: '/subcon' },
}

export const isArea = (v: unknown): v is Area => typeof v === 'string' && (AREAS as readonly string[]).includes(v)
